import { useQuery } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerCausesResponse } from './types';

const useListConsumerCauses = () => {
  const BackerApi = useBackerApi();

  const getConsumerCauses = async () => {
    const { data } = await BackerApi.get<ConsumerCausesResponse>('/consumer/causes');
    return data;
  };

  return useQuery({
    queryKey: backerKeys.consumer.causes.all,
    queryFn: getConsumerCauses,
  });
};

export { useListConsumerCauses };
